import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { Observable, pipe, switchMap, tap } from "rxjs";
import { BannerBackOfficeViewModel } from "@playcharge/common/models/backend/banners/backoffice/banner-backoffice-view-model";
import { ApiBannersService } from "../../services/api-banners.service";
import { BannerEditModel } from "@playcharge/common/models/backend/banners/backoffice/banner-edit-model";

export type BannersStore = InstanceType<typeof BannersStore>;

export const BannersStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<BannerBackOfficeViewModel>(),
    withRequestStatus(),
    withMethods((store, apiBannersService = inject(ApiBannersService)) => ({
        loadBanners: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiBannersService.getBanners().pipe(
                        tap((banners) => {
                            patchState(store, setAllEntities(banners));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        createBanner(model: BannerEditModel): Observable<BannerBackOfficeViewModel> {
            return apiBannersService
                .createBanner(model)
                .pipe(tap((banner) => patchState(store, setEntity(banner))));
        },
        updateBanner(model: BannerEditModel): Observable<BannerBackOfficeViewModel> {
            return apiBannersService
                .updateBanner(model)
                .pipe(tap((banner) => patchState(store, setEntity(banner))));
        },
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadBanners();
        },
    })),
);
